import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const SaveButton: React.FC<any> = ({ stageRef }) => {
  const { t } = useTranslation();
  const downloadImg = () => {
    const currentStageRef: any = stageRef.current;

    let dataUrl: string;
    dataUrl = currentStageRef.toDataURL({ pixelRatio: 1 });

    downloadURI(dataUrl, "BroadCast.png");
  };
  function downloadURI(uri: string, name: string) {
    const link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);

    link.click();
  }
  return (
    <>
      <Grid item>
        <Button
          variant="contained"
          onClick={downloadImg}
          color="secondary"
          fullWidth
        >
          {t("actionButtons.saveButton")}
        </Button>
      </Grid>
    </>
  );
};

export default SaveButton;
